import {makeTopic} from "../../topic/topic";

export function makeFilterTopic(observers) {
    const topic = makeTopic({
        years: [],
        keywords: [],
    }, observers)

    return {
        set(prop, value) {
            topic.setState({...topic.getState(), [prop]: value})
        },
        getYears() {
            return topic.getState().years
        },
        addYear(year) {
            this.set("years", [...topic.getState().years, year])
        },
        removeYear(year) {
            this.set("years", topic.getState().years.filter(y => y !== year))
        },
        getKeywords() {
            return topic.getState().keywords
        },
        hasKeyword(keyword) {
            return topic.getState().keywords.indexOf(keyword) > -1
        },
        addKeyword(keyword) {
            this.set("keywords", [...topic.getState().keywords, keyword])
        },
        removeKeyword(keyword) {
            this.set("keywords", topic.getState().keywords.filter(k => k !== keyword))
        },
        isFilterSet() {
            const {years, keywords} = topic.getState()
            return years.length > 0 || keywords.length > 0
        }
    }
}